import statuses from '@/store/statuses';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    rolesList: {
      data: {},
      status: statuses.EMPTY,
    },
    roleCreateData: {
      data: {},
      status: statuses.EMPTY,
    },
    roleUpdateData: {
      data: {},
      status: statuses.EMPTY,
    },
    roleCreate: {
      data: {},
      status: statuses.EMPTY,
    },
    roleUpdate: {
      data: {},
      status: statuses.EMPTY,
    },
  };
};

const store = {
  namespaced: true,
  state: defaultState,
  getters: {
    rolesList: (state) => state.rolesList,
    roleCreateData: (state) => state.roleCreateData,
    roleUpdateData: (state) => state.roleUpdateData,
    roleCreate: (state) => state.roleCreate,
    roleUpdate: (state) => state.roleUpdate,
  },
  mutations,
  actions,
};

export { store, defaultState };
